import { Translate } from '@dnd-kit/core';

export function gridObjectTransform(
  dragTransform: Translate | null,
  zoom: number
): string | undefined {
  if (!dragTransform) return undefined;
  return `translate3d(${dragTransform.x / zoom}px, ${
    dragTransform.y / zoom
  }px, 0)`;
}

export function gridObjectRotationTransform(
  rotationDeg: number
): string | undefined {
  return rotationDeg === 0 ? undefined : `rotate(${rotationDeg}deg)`;
}
